import { useContext } from 'react';

import { AdDataContext } from '../../shared/context';
import type { LocationChangeValue } from './types';

export function useLocationChange(): LocationChangeValue {
  const adContext = useContext(AdDataContext);

  return {
    setContentUrl: adContext.operations.setContentUrl,
    setFullContentUrl: adContext.operations.setFullContentUrl,
  };
}
